import underline from "./assets/underlinea.png";

import teams from "./data/teams.json";
import ProfileCard from "./ProfileCard";

const HeroSection = () => {
  return (
    <section className="w-full bg-[#fdf6dc] pb-8 lg:pb-16">
      {/* Header */}
      <div className="text-center px-4 pt-8 lg:pt-16">
        <h2 className="text-3xl sm:text-[48px] text-[#1E1E1E] leading-tight">
          People of Lentera
        </h2>
        <img
          src={underline}
          alt="underline"
          className="mx-auto mt-2 w-[80px] h-[2px]"
        />

        <p className="mt-6 md:text-sm sm:text-lg text-[#3A3A3A] max-w-[450px] mx-auto leading-relaxed">
          A behind-the-scenes look at the people who shaped our craft— building
          the foundation of our culture and the products we proudly create
          today.
        </p>
      </div>

      <div className="max-w-7xl mx-auto mt-8 lg:mt-16 flex justify-center">
        <div
          className="
              inline-grid
              mx-auto
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-3
              gap-6
              xl:gap-x-12
              md:gap-y-32
              place-items-center 
            "
        >
          {teams.map((item, index) => (
            <ProfileCard key={index} specialist={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
